import type { DevScenario } from '@arya/shared/domain';
import type { MockApiErrorBody } from '@arya/shared/msw-cloudflare';
import { devScenarioRequest } from '@arya/shared/msw-cloudflare';

import { http, HttpResponse } from 'msw';

export const MARKET_PROJECTS_FAILURE_SCENARIO: DevScenario = {
  name: 'market-500',
  group: 'Market list',
  title: 'Server error',
  description: 'The project list fails to load: error state with a retry.',
  screen: '/market',
};

export const marketProjectsFailureHandler = http.all(
  devScenarioRequest({ method: 'GET', path: '/api/market/projects' }, MARKET_PROJECTS_FAILURE_SCENARIO),
  () => {
    const body: MockApiErrorBody = { error: { message: 'boom' } };
    return HttpResponse.json(body, { status: 500 });
  }
);
